import { useIntl } from 'react-intl';
import { jsx, Fragment } from 'react/jsx-runtime';

const getMessage = (props, intl) => {
  if (props.cascade && props.cascade.length > 0) {
    const match = props.cascade.find(item => {
      return intl.messages[item.id];
    });
    const found = match != null ? match : props.cascade.slice(-1)[0];
    const values = Object.assign({}, props.values, found.values);
    return getMessage({
      ...found,
      values
    }, intl);
  }
  const {
    id,
    values
  } = props;
  if (id != null && id !== '') {
    return intl.formatMessage({
      id
    }, values);
  }
  return '';
};
var getMessage$1 = getMessage;

const useMessage = props => getMessage$1(props, useIntl());
var useMessage$1 = useMessage;

const Message = props => /*#__PURE__*/jsx(Fragment, {
  children: useMessage$1(props)
});
var Message$1 = Message;

export { Message$1 as Message, Message$1 as default, getMessage$1 as getMessage, useMessage$1 as useMessage };
